import React from 'react';
import SectionHeader from '../../ui/SectionHeader';
import ArticlePreviewList from '../../ui/ArticlePreviewList';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { TagItem } from '../../../shared/types';
import { Loader } from 'neon-design-system';
import { TAG } from '../../../gql/tags';
import { useActivityLogger } from '../../hooks/use-activity-logger';

const TagPage = () => {
	const { _id } = useParams();

	const { data, loading } = useQuery<{ document: TagItem }>(TAG, {
		skip: !_id,
		fetchPolicy: 'network-only',
		variables: { id: _id }
	});

	useActivityLogger('Tag', data?.document?.name, data?.document?._id);

	if (!data || loading) {
		return <Loader />;
	}

	const { document: tag } = data;

	return (
		<Grid item xs={12}>
			<SectionHeader
				id="tag-header-section"
				title={`All articles tagged '${tag?.name}'`}
				subtitle="An aggregation of articles that have the same tag"/>
			<ArticlePreviewList
				tagId={_id}
				source="Tag Page" />
		</Grid>
	);
};

export default TagPage;
